import { render, staticRenderFns } from "./trendingTags.vue?vue&type=template&id=5f59edff&scoped=true"
import script from "./trendingTags.vue?vue&type=script&lang=js"
export * from "./trendingTags.vue?vue&type=script&lang=js"
import style0 from "./trendingTags.vue?vue&type=style&index=0&id=5f59edff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59edff",
  null
  
)

export default component.exports